import { Link, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { LINKS } from "shared/config";
import FooterItems from "../FooterItems/FooterItems";

export default function Footer() {
  const theme = useTheme();

  return (
    <Box
      bgcolor={theme.palette.primary.main}
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        height: "40px",
        width: "100%",
        display: { xs: "none", sm: "none", md: "flex" },
        alignItems: "center",
        fontSize: "0.7rem",
        paddingInline: "24px",
        zIndex: 1050,
      }}
    >
      <Box>
        <FooterItems />
      </Box>
      <Box sx={{ color: "#7c9dbe", marginInlineStart: "auto" }}>
        Created by{" "}
        <Link
          href={LINKS.process_automation}
          target="_blank"
          rel="noreferrer"
          sx={{
            color: "#7c9dbe",
            textDecoration: "none",
            "&:hover": { color: "white" },
          }}
        >
          &rarr; Process Automation &larr;
        </Link>{" "}
        team
      </Box>
    </Box>
  );
}
